/********************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2021, 2024
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} **/
import React from 'react';
import { Table, TableHead, TableRow, TableHeader, TableBody, TableCell } from '@carbon/react';
import { useKafkaProperties } from 'hooks/kafkaProperties';
import { useTranslation } from 'react-i18next';

const KafkaPropertiesTable = ({ channelName, operationId, ...other }) => {
  const { t } = useTranslation();
  const properties = useKafkaProperties(channelName, operationId);
  const headers = [t('key'), t('value')];

  return (
    <div className="channel__information">
      <div role="heading" aria-level={3} className="channel__label">
        {t('properties')}
      </div>
      <div className="channel__value">
        <Table {...other}>
          <TableHead>
            <TableRow>
              {headers.map((header) => (
                <TableHeader key={header}>{header}</TableHeader>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {properties.map((property) => (
              <TableRow tabIndex={0} key={property.key}>
                {Object.keys(property).map((key) => {
                  return <TableCell key={key}>{property[key]}</TableCell>;
                })}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};

export default KafkaPropertiesTable;
